
import { useRef, useState } from 'react';
import { Message } from '@/lib/session';
import { ChatMessages } from './ChatMessages';
import { ScrollToBottomButton } from './ScrollToBottomButton';

interface ChatContainerProps {
  messages: Message[];
  isLoading: boolean;
  isSharedSession: boolean;
}

export const ChatContainer = ({ messages, isLoading, isSharedSession }: ChatContainerProps) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.clientHeight < 100;
    setShowScrollButton(!bottom);
  };

  return (
    <div className="flex-1 overflow-visible relative" onScroll={handleScroll}>
      <ChatMessages 
        messages={messages}
        isLoading={isLoading}
        messagesEndRef={messagesEndRef}
        isNewMessage={!isSharedSession}
      />
      <ScrollToBottomButton 
        onClick={scrollToBottom} 
        isVisible={showScrollButton} 
      />
    </div>
  );
};
